import { useState, useEffect } from "react";
import { loginCustomer } from "../../services/Api";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loggedIn } from "../../redux-setup/reducers/auth";
import { useNavigate } from "react-router-dom";
const Login = () => {
  const [formInputs, setFormInputs] = useState({});
  const [errorLogin, setErrorLogin] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const changeFormInputs = (e) => {
    const { name, value } = e.target;
    return setFormInputs({ ...formInputs, [name]: value });
  };
  const clickLogin = (e) => {
    loginCustomer(formInputs)
      .then(({ data }) => {
        // console.log("dafjdkaljfldsajlf"); //trả về Obj, trong đó có Obj customer
        // console.log(data); //trả về Obj, trong đó có Obj customer
        dispatch(loggedIn({ ...data.customer, accessToken: data.accessToken }));
        return navigate("/");
      })
      .catch((error) => {
        if (error.response.data === "Email not valid") {
          return setErrorLogin("Email không hợp lệ!");
        }
        if (error.response.data === "Password not valid") {
          return setErrorLogin("Password không hợp lệ!");
        }
        return console.log(error);
      });
  };
  return (
    <>
      {/*	Login Form	*/}
      <div id="customer">
        {errorLogin && (
          <div
            className={`alert ${
              errorLogin ? "alert-success" : "alert-danger"
            } text-center`}
          >
            {errorLogin}
          </div>
        )}
        <h3 className="text-center">Đăng nhập</h3>
        <form method="post">
          <div className="row">
            <div id="customer-mail" className="col-lg-6 col-md-6 col-sm-12">
              <input
                onChange={changeFormInputs}
                placeholder="Email (bắt buộc)"
                type="text"
                name="email"
                className="form-control"
                required
              />
            </div>
            <div id="customer-pass" className="col-lg-6 col-md-6 col-sm-12">
              <input
                onChange={changeFormInputs}
                placeholder="Mật khẩu (bắt buộc)"
                type="text"
                name="password"
                className="form-control"
                required
              />
            </div>
          </div>
        </form>
        <div className="row">
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <Link onClick={clickLogin} to="#">
              <b>Đăng nhập ngay</b>
            </Link>
          </div>
          <div className="by-now col-lg-6 col-md-6 col-sm-12">
            <Link to="/">
              <b>Quay về trang chủ</b>
            </Link>
          </div>
        </div>
      </div>
      {/*	End Login Form	*/}
    </>
  );
};
export default Login;
